import React from 'react';

import { Alert, Typography } from '@mui/material';
import { PROFILE_EMAIL_VERIFICATION_STATUS_ALERT_ID } from '../validation';
import { useUserProfileStrings } from './userProfile-strings';

type EmailVerificationProps = {
    isEmailVerified: boolean;
    verificationError?: string;
    hasCheckedVerification?: boolean;
    successType?: 'email_sent' | 'email_verified' | null;
};

export default function EmailVerification({ isEmailVerified, verificationError, hasCheckedVerification, successType }: EmailVerificationProps) {
    const profileStrings = useUserProfileStrings();

    if (isEmailVerified) {
        return null; // Don't show anything when verified - the inline status is handled in UserProfileComp
    }

    const statusAlert = successType === 'email_sent' ? (
        <Alert id={PROFILE_EMAIL_VERIFICATION_STATUS_ALERT_ID} severity="success">
            <Typography variant="body2">
                {profileStrings.verificationEmailSentBanner}
            </Typography>
        </Alert>
    ) : successType === 'email_verified' ? (
        <Alert id={PROFILE_EMAIL_VERIFICATION_STATUS_ALERT_ID} severity="success">
            <Typography variant="body2">
                {profileStrings.emailVerifiedSuccessBanner}
            </Typography>
        </Alert>
    ) : verificationError ? (
        <Alert id={PROFILE_EMAIL_VERIFICATION_STATUS_ALERT_ID} severity="error">
            <Typography variant="body2">
                {verificationError}
            </Typography>
        </Alert>
    ) : hasCheckedVerification ? (
        <Alert id={PROFILE_EMAIL_VERIFICATION_STATUS_ALERT_ID} severity="warning">
            <Typography variant="body2">
                {profileStrings.emailNotVerifiedAfterCheckBanner}
            </Typography>
        </Alert>
    ) : null;

    if (!statusAlert) {
        return null;
    }

    return statusAlert;
}
